import React, { useState } from 'react';
import { STORAGE_TYPE } from 'constant';
import Form from 'screens/shared/form';

export const EditStorage = ({
  id, storagesFields, editValue, onSave, deselectToEdit, validations, type, getChangeFields,
}) => {
  const [storage, setStorage] = useState(editValue);
  const [selectedImage, setSelectedImage] = useState({});

  const fields = [...storagesFields];
  fields.map((item) => {
    if (item.name === 'image') {
      item.onChange = (value) => setSelectedImage(value);
    }
    return item;
  });

  return (
    <Form
      fields={fields}
      fieldsValues={storage}
      onSubmit={onSave}
      onCancel={() => deselectToEdit(id)}
      validations={validations}
      changeFields={type === STORAGE_TYPE.DAS ? [
        { name: 'size', props: { disabled: true } },
        { name: 'availabilityZone', props: { disabled: true } },
        { name: 'type', props: { options: [STORAGE_TYPE.DAS], disabled: true } },
      ] : getChangeFields(selectedImage)}
      onChange={(value) => {
        setStorage(value);
      }}
    />
  );
};
